var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rich-text-editor-wrapper",class:{ 'rte-dark': _vm.isDark },staticStyle:{"position":"relative"}},[_c('div',{ref:"editorContainer",attrs:{"id":_vm.editorId}}),(_vm.uploading)?_c('div',{staticClass:"rte-upload-overlay"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Uploading image... ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }